<template>
    <section>
        <div class="banner">
            <top-banner banner-image="account-confirmation">
                <div class="flex items-center justify-center h-full">
                    <div class="text-center header-padding">
                        <div class="header-box">
                            <h2 class="confirmation-header" v-text="$t('CONFIRMATION_WELCOME_TO')"></h2>
                            <h2 class="confirmation-header-text" v-text="$t('CONFIRMATION_FF')"></h2>
                        </div>
                    </div>
                </div>
            </top-banner>
        </div>
        <!-- Small gap -->
        <div class="clear--xs"></div>
        <div id="content-start" class="max-w-sm mx-auto">
            <p class="text-center mx-2" v-text="$t('CONFIRMATION_WE_ARE_SO')"></p>
            <p class="text-center mx-2" v-html="$t('CONFIRMATION_BEFORE_YOU')"></p>
            <!-- Tiny gap -->
            <div class="clear--xs"></div>
            <div class="flex flex-col justify-center mx-4">
                    <!-- Post checkout questions radio field -->
                    <div
                        v-for="postCheckoutQuestion in postCheckoutQuestions" :key="postCheckoutQuestion.id"
                        class="input__radio">
                        <input
                            :id="`post-checkout-question-${postCheckoutQuestion.id}`"
                            name="post-checkout-question"
                            class="input__radio-item"
                            type="radio"
                            :value="postCheckoutQuestion.name"
                            v-model="postCheckoutAnswer">
                        <label class="input__radio-label" :for="`post-checkout-question-${postCheckoutQuestion.id}`">
                            {{ postCheckoutQuestion.name }}
                        </label>
                    </div>
                    <!-- Tiny gap -->
                    <div class="clear--xs"></div>
                    <router-link :to="{ name: 'account.dashboard' }" class="btn btn--primary next-step__btn">
                        {{ $t('CONFIRMATION_NEXT_STEP') }}
                    </router-link>
            </div>
        </div>
        <!-- Small gap -->
        <div class="clear--sm"></div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import * as moment from 'moment';
import TopBanner from '@/components/structure/TopBanner';
import PostCheckoutService from '@/services/users/PostCheckoutService';
import { gaConversion } from '@/helpers/GAHelpers';

let postCheckoutService = new PostCheckoutService();

export default {
    name: 'Confirmation',
    data() {
        return {
            subscriptionId: null,
            isFormProcessing: false,
            postCheckoutAnswer: null,
            postCheckoutQuestions: [],
            isProduction: process.env.NODE_ENV === 'production',
        };
    },
    mounted() {
        this.subscriptionId = this.$route.params.subscriptionId;
        this.getPostCheckoutQuestions(this.subscriptionId);
        this.sendOptimusMetrics();
        gaConversion('conversion', process.env.VUE_APP_GOOGLE_ANALYTICS_SEND_TO, this.subscriptionId);
    },
    computed: {
        ...mapGetters({
            userProperty: 'account/getUserProperty',
            couponCode: 'account/getSignupCoupon',
            subscription: 'subscription/getActiveSubscription',
        }),
        nextDeliveryDate() {
            return this.subscription && this.subscription.next_delivery_date ? moment(this.subscription.next_delivery_date).format('YYYY-MM-DD') : '';
        },
        userObject() {
            const id = this.userProperty('id');
            const email = this.userProperty('email');

            return {
                id,
                email,
            };
        },
        price() {
            return process.env.VUE_APP_BOX_PRICE;
        },
    },
    methods: {
        sendOptimusMetrics() {
            const coupon = this.couponCode || null;
            const parsedImpactKey = Number(process.env.VUE_APP_IMPACT_KEY);

            ire('trackConversion', parsedImpactKey, {
                orderId: this.userId,
                coupon,
            });

            if (window.AWIN && window.AWIN.Tracking) {
                window.AWIN.Tracking.Sale = {};
                window.AWIN.Tracking.Sale.amount = '1';
                window.AWIN.Tracking.Sale.channel = 'aw';
                window.AWIN.Tracking.Sale.orderRef = this.userObject.id;
                window.AWIN.Tracking.Sale.parts = `DEFAULT:1`;
                window.AWIN.Tracking.Sale.currency = 'EUR';
                window.AWIN.Tracking.Sale.voucher = coupon || '';
                window.AWIN.Tracking.Sale.test = process.env.VUE_APP_ENV === 'Production' ? '0' : '1';
                window.AWIN.Tracking.run();
            }

            let awPixel = new Image(0, 0);
            awPixel.src = `https://www.awin1.com/sread.img?tt=ns&tv=2&merchant=${process.env.VUE_APP_AWIN_KEY}&amount=1&ch=aw&parts=DEFAULT:1&ref=${this.userObject.id}${coupon ? '&vc=' + coupon : '&vc='}&cr=EUR&testmode=0`;
            document.body.appendChild(awPixel);
        },

        async getPostCheckoutQuestions(subscriptionId) {
            this.postCheckoutQuestions = await postCheckoutService.getPostCheckoutQuestions(subscriptionId);
        },

        async saveUserPostCheckoutAnswer(postCheckoutAnswer) {
            await postCheckoutService.saveUserPostCheckoutAnswer(postCheckoutAnswer);
        },
    },
    watch: {
        postCheckoutAnswer(value) {
            this.saveUserPostCheckoutAnswer(value);
        },
    },
    components: {
        TopBanner,
    },
};
</script>

<style lang="scss" scoped>
.header-box {
    max-width: 400px;
    width: 100%;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.header-padding {
    padding-top: 20px;
}

.confirmation-header {
    display: flex;
    text-align: center;
    margin: auto 0;
    font-size: 15px;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    font-weight: 600;
    line-height: 20px;
    max-width: 200px;
    @screen md {
        font-size: 15px;
        line-height: 22px;
        max-width: 300px;
    }
    @screen lg {
        font-size: 20px;
        line-height: 22px;
        max-width: 320px;
    }
}
.next-step__btn {
    min-width: 180px;
    text-align: center;
}

.confirmation-header-text {
    display: flex;
    text-align: center;
    margin: auto 0;
    font-size: 34px;
    font-family: 'FreddiesFlowersTitle';
    line-height: 30px;
    max-width: 200px;
    padding: 0.1em;
    @screen md {
        font-size: 50px;
        line-height: 40px;
        max-width: 300px;
    }
    @screen lg {
        font-size: 60px;
        line-height: 45px;
        max-width: 320px;
    }
}
</style>
